import { model as i18n } from '!/i18n'
import { api } from '@setplex/tria-api'
import { combine } from 'effector'

export const $eventsDetails = combine(i18n.$t, ({ t }) => ({
  liveTitle: t('live_now'),
  titleButton: t('more'),
  playButton: t('play'),
  popupDescriptionTitle: t('description'),
  titleTimer: t('event_starts_in'),
  episodePopup: t('event_one'),
  daysTitleTimer: t('day_other'),
  hoursTitleTimer: t('hour_other'),
  minutesTitleTimer: t('minute_other'),
  secondsTitleTimer: t('second_other'),
  popupTitle: t('event_one'),
}))

export const $paymentButtonText = combine(
  i18n.$t,
  api.liveEvents.$liveEvent,
  ({ t }, liveEvent) =>
    t('purchase_for', {
      currency: liveEvent?.minCurrency,
      price: liveEvent?.minPrice,
    })
)
